<template>
  <div class="h-100 p-5">
    <h3>Customer not found.</h3>
    <p class="mt-3">Please specify email address and we will send you the correct link.</p>
    <div class="hvh-flex col-12 col-md-9 col-xl-6 p-0">
      <v-text-field label="Email Address" :hideDetails="true" outline />
      <v-btn flat class="hvh-btn hvh-btn--secondary ml-5">Send</v-btn>
    </div>
  </div>
</template>

<script>
import axios from '../../axios';
import { errorDebug } from '../../libraries/common';
export default {
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
}
</script>
